/**
 * The fixed notice (D1 UX 2). Not dismissible, and rendered by the page outside
 * every state branch, so it is there when the log loads, when it is empty and
 * when it fails: the scope of what is shown must never be in doubt.
 */
export function ScopeNotice() {
    return (
        <p
            className="mb-5 rounded-lg border border-line bg-surface-sunken px-4 py-3 text-[13px] leading-relaxed text-content-body"
            data-testid="unidentified-refusals-scope-notice"
        >
            Only refusals with no identified tenant are shown. A tenant&apos;s refusals are seen by
            that tenant in its own audit
        </p>
    );
}
